module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-39-9be1cdf6cd63082e15cec965e2dcb6db.svg";